import React, { useState, useEffect, useContext } from "react";
import { CardBody, Button, Col, Row } from "react-bootstrap";
import { Bar } from "react-chartjs-2";
import Chart from "chart.js/auto";
import YouTube from "react-youtube";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowAltCircleRight } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import {
  InputValidationConstants,
  InputControl,
  RadioControl,
  SelectControl,
  CheckboxControl,
  NumberControl,
  DateTimeControl,
  TextAreaControl,
  AutocompleteControl,
} from "wup-module1-base";
import MonthYearInput from "./MonthYearInput";

import { XCircle, QuestionLine, IconInfo } from "../../images/icons";
import { SurveyService } from "../../Services";
import { maxTime } from "date-fns";
import UserContext from "../../Contexts/UserContext";
import { AppHelpers } from "../../Helpers/App/AppHelpers";
import "./Question.css";
import {
  M1_AnswersTypeEnum,
  M1_ContentVideoStatuses,
  M1_QuestionTypeEnum,
} from "../../Constants/Enums";

const Question = ({
  question,
  register,
  errors,
  handleInputChange,
  previousFormValues,
  conditionsArray,
  surveyArray,
  currentPage,
  getValues,
  setValue,
  setAreasHelper,
  unregister,
  columnCopiedAnswersData,
  setColumnCopiedAnswersData,
  columnCopiedQuestionnaire,
  setColumnCopiedQuestionnaire,
  setIsVideoEnded,
  setError,
  clearErrors,
  reset,
  downloadFeedbackPDF,
  developmentAreas,
  setDevelopmentAreas,
  setForceReloadHelper
}) => {
  const [inputSets, setInputSets] = useState([]);
  const [inputElement, setInputElement] = useState();
  const [isTableInit, setIsTableInit] = useState(false);
  const [selectedId, setSelectedId] = useState();
  const { user } = useContext(UserContext);
  const [setsIndex, setSetsIndex] = useState();
  const [areas, setAreas] = useState([]);
  const [timer, setTimer] = useState(null);
  const [deleteTableRowTrigger, setDeleteTableRowTrigger] = useState(1);
  const [tableTrigger, setTableTrigger] = useState(1);
  const [copiedColumnTrigger, setCopiedColumnTrigger] = useState(1);
  const [areaTrigger, setAreaTrigger] = useState(1);
  const [shouldRerender, setShouldRerender] = useState(true);
  const [currentAreas, setCurrentAreas] = useState([]);
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const [competitions, setCompetitions] = useState("Moje mocne strony");
  const handleAddAreaRow = (value , id) => {

    if (!!value && !!id) {
      
      let areaObj={
        name: value,
        id: id
      }
      if(areas?.length === developmentAreas?.length){
      setDevelopmentAreas((prevAreas) => [...prevAreas, areaObj]);
      }
      setAreas((prevAreas) => [...prevAreas, value]);
      setValue("area", "");

      let newAreasText =
        areas.length > 0 ? areas.join("; ") + "; " + value : value;
      setValue(question.selector_id, newAreasText);
    }
  };

  //funkcja dodajaca tabele w tabeli
  const handleAddTableRow = (index) => {
    let text = "";
    let shouldAdd = true;

    question.answers?.forEach((option) => {
      if (
        getAnswerType(option.content) ===
        M1_AnswersTypeEnum.MultipleColumn.value
      ) {
        if (
          !getValues(`answer_${question.selector_id}_${option.id}_${index}`)
            .replace(/[:|;]/g, " ")
            .trim()
        ) {
          shouldAdd = false;
          text = "";
        } else {
          text +=
            labelName(option.content) +
            ": " +
            getValues(
              `answer_${question.selector_id}_${option.id}_${index}`
            ).replace(/[:|;]/g, " ") +
            " | ";
        }
      }
    });

    if (!shouldAdd) {
      toast.error(
        `Przed zatwierdzeniem uzupełnij oba pola dotyczące zadań i kompetencji`
      );
    }

    !!shouldAdd &&
      question.answers?.forEach((option) => {
        setValue(`answer_${question.selector_id}_${option.id}_${index}`, "");
      });

    !!shouldAdd &&
      setAreas((prevAreas) => {
        const updatedAreas = [...prevAreas];
        updatedAreas[index] = {
          ...updatedAreas[index],
          text: [...(updatedAreas[index]?.text || []), text],
        };
        return updatedAreas;
      });
  };

    useEffect(() => {
    const SECRET_UUID = "550e8400-e29b-41d4-a716-446655440000";

    const onEndVideo = () => {
      setIsVideoEnded(M1_ContentVideoStatuses.Valid.value);
    };

    window.triggerVideoEnd = (uuid) => {
      if (uuid !== SECRET_UUID) {
        return;
      }

      onEndVideo();
    };

    return () => {
      delete window.triggerVideoEnd;
    };
  }, []);

  const onEndVideo = () => {
    setIsVideoEnded(M1_ContentVideoStatuses.Valid.value);
  };

  useEffect(() => {
    if (question.type === M1_QuestionTypeEnum.Area.value) {
      setAreaTrigger((prev) => prev + 1);
    }
  }, [areas]);

  const handleRemoveAreaRow = (indexToRemove) => {
    if (areas.length < 2) {
      unregister(question.selector_id);
    }

    if(areas.length === developmentAreas.length){
    setDevelopmentAreas((prevAreas) =>
      prevAreas.filter((_, index) => index !== indexToRemove)
    );
  }

    setAreas((prevAreas) =>
      prevAreas.filter((_, index) => index !== indexToRemove)
    );

  };

  const handleRemoveTableRow = (indexForSet, indexToRemove) => {
    unregister(`answer_${question.selector_id}_table_${indexForSet}`);

    setAreas((prevAreas) =>
      prevAreas.map((area, index) =>
        index === indexForSet && area.text
          ? { ...area, text: area.text.filter((_, i) => i !== indexToRemove) }
          : area
      )
    );
  };

  function setNewTextForArea() {
    let newAreasText = areas.length > 0 ? areas.join("; ") : "";
    setValue(question.selector_id, newAreasText);
  }

  useEffect(() => {
    reset(setNewIndexForTable(getValues()));
    let setsLenght = getHighestIndexFromSets(getValues(), question.selector_id);
    if (!!setsLenght) {
      setSetsIndex(setsLenght);
    } else {
      setSetsIndex(1);
    }
  }, [deleteTableRowTrigger]);

  useEffect(() => {
    if (question.type === M1_QuestionTypeEnum.Table.value) {
      setAreasHelper(areas);
      areas.forEach((area, index) => {
        if (area && area.text) {
          let connectedText = "";

          area.text.forEach((item) => {
            connectedText += item + ";";
          });

          setValue(`${question.selector_id}_table_${index}`, connectedText);
        }
      });
    } else {
      if (areas.length > 0) {
        setNewTextForArea();
      }
    }
  }, [areas]);

  function searchDevelopmentArea(query) {
    return new Promise((resolve, reject) => {
      if (timer) {
        clearTimeout(timer);
      }

      const newTimer = setTimeout(() => {
        if (query.length >= 4) {
          SurveyService.getDevelopmentAreas(query)
            .then((response) => {
              setCurrentAreas(() => response?.data);

              const areaOptions = response.data.map((item) => {
                let labelString = `${item.name}`;

                item.paths.forEach((path) => {
                  labelString += ` (Kategoria: ${path[0]}, podkategoria: ${path[1]})`;
                });

                let obj = {
                  id: item.id,
                  name: labelString
                }

                return obj;
              });

              resolve(areaOptions);
            })
            .catch((error) => {
              console.error(error);
              reject(error);
            });
        }
      }, 2000);

      setTimer(newTimer);
    });
  }

  //walidowanie checkbox w liscie
  const validateCheckboxes = (selector_id) => {
    let data = getValues();
    let trueCount = 0;
    let minCount = question?.required ? 1 : 0;
    let validationObj = null;
    if (!!question.validation_rules) {
      validationObj = JSON.parse(question.validation_rules);
    }
    let maxCount = validationObj?.maxValue ?? 10000;

    for (const key in data) {
      if (key.startsWith(selector_id)) {
        if (data[key] === true) {
          trueCount++;
        }
      }
    }
    clearErrors(selector_id);
    if (minCount > trueCount) {
      setError(selector_id, {
        type: "manual",
        message: `Proszę zaznaczyć conajmniej ${minCount} opcję`,
      });
    } else if (trueCount > maxCount) {
      setError(selector_id, {
        type: "manual",
        message: `Oczekiwano maksymalnie ${minCount} zaznaczonych opcji`,
      });
    }
  };

  useEffect(() => {
    const inputElements = inputSets?.map((inputSet, setIndex) => (
      <div key={`set_2_${setIndex}`}>
        {inputSet}
        {areas.length > 0 && (
          <div className="bg-white">
            {areas[setIndex + 1]?.text?.map((area, index) => (
              <Row key={index}>
                <Col md={10}>{area}</Col>
                <Col md={2}>
                  <Button
                    className="btn-sm mx-2 btn-delete"
                    type="button"
                    variant="danger"
                    onClick={() => handleRemoveTableRow(setIndex + 1, index)}
                  >
                    <span>
                      <img className="delete-btn" src={AppHelpers.svgBase64(XCircle)} alt="usuń" />
                      usuń
                    </span>
                  </Button>
                </Col>
              </Row>
            ))}
          </div>
        )}

        <Button
          className="btn-sm mx-2 btn-delete"
          type="button"
          variant="danger"
          onClick={() => handleDeleteSet(setIndex)}
        >
          <span>
            <img className="delete-btn" src={AppHelpers.svgBase64(XCircle)} alt="usuń" />
            usuń informacje
          </span>
        </Button>
      </div>
    ));

    setInputElement(
      <div>
        {inputElements}
        <Button
          className="float-right btn-sm px-3 btn-add"
          type="button"
          onClick={handleAddSetIndex}
        >
          Dodaj
        </Button>
      </div>
    );
  }, [tableTrigger]);

  //useEffect to obsłużenia powiązanej kolumny
  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (
      !!columnCopiedQuestionnaire &&
      !!columnCopiedAnswersData &&
      inputSets?.length === 0
    ) {
      let rowsLenght = 0;
      let quest7;
      let copied_column_props;
      let copied_columns_table = [];
      question.answers.map((option) => {
        if (!!option.copied_column_def) {
          copied_column_props = JSON.parse(option.copied_column_def);
          copied_columns_table.push({
            option: option,
            props: copied_column_props,
          });
          quest7 = getQuestionForOption(option, copied_column_props);
          let newRowsLenght = getHighestIndexFromSets(
            columnCopiedAnswersData,
            quest7.selector_id
          );
          if (newRowsLenght > rowsLenght) {
            rowsLenght = newRowsLenght;
          }
        }
      });

      let areasString = "";
      let table = [];
      for (let x = 0; x < rowsLenght; x++) {
        for (const key in columnCopiedAnswersData) {
          if (key === `${quest7.selector_id}_table_${x + 1}`) {
            areasString = columnCopiedAnswersData[key];
          }
        }

        if (areasString) {
          let areasArray = areasString
            .split(/\|\s?;/)
            .map((area) => area.trim());
          areasArray?.forEach((element) => {
            if (element) {
              table.push(element);
            }
          });
        }
      }
      let index = 1;

      table.forEach((row) => {
        handleAddSet(index);
        let helper = 0;
        copied_columns_table.forEach((item) => {
          if (!!item && !!table[index - 1]) {
            let text = table[index - 1]?.toString();
            let textToInsert = "";

            let currentColonPosition = -1;
            let currentPipePosition = -1;

            for (let i = 1; i <= helper + 1; i++) {
              currentColonPosition = text.indexOf(
                ":",
                currentColonPosition + 1
              );
              currentPipePosition = text.indexOf("|", currentPipePosition + 1);
            }

            if (currentPipePosition === -1) {
              currentPipePosition = text.length - 1;
            }

            textToInsert = text
              .substring(currentColonPosition + 1, currentPipePosition + 1)
              .trim();

            textToInsert = textToInsert.replace(/\|/g, "");

            setValue(
              `answer_${question.selector_id}_${item.option.id}_${index}`,
              textToInsert
            );
            helper++;
          }
        });
        index++;
      });
    }
  }, [copiedColumnTrigger]);

  //useEffect do wyświetlenie powiązanej kolumny
  useEffect(() => {
    if (!!columnCopiedQuestionnaire && !!columnCopiedAnswersData) {
      const inputElements = inputSets?.map((inputSet, setIndex) => (
        <div key={`set_${setIndex}`}>{inputSet}</div>
      ));
      setInputElement(<div>{inputElements}</div>);
    }
  }, [inputSets]);

  const getQuestionForOption = (option) => {
    let copied_column_props = JSON.parse(option.copied_column_def);

    const pageWithQuestion = columnCopiedQuestionnaire.pages.find((page) =>
      page.questions.some(
        (question) => question.id === copied_column_props.question_id
      )
    );

    if (pageWithQuestion) {
      return pageWithQuestion.questions.find(
        (question) => question.id === copied_column_props.question_id
      );
    } else return "";
  };

  const handleAddSetIndex = () => {
    setSetsIndex((prevIndex) => prevIndex + 1);
  };

  const checkForAnswers = (index, isNeedValidation) => {
    let data = getValues(`${question.selector_id}_table_${index}`);
    if (!isNeedValidation) {
      return true;
    } else {
      if (data?.length > 0) {
        clearErrors(`table_${index}`);
        return true;
      } else {
        setError(`table_${index}`, {
          type: "manual",
          message: "error",
        });
        setForceReloadHelper((prev) => prev + 1);
        return false;
      }
    }
  };

  const checkForAnswers1 = () => {
    if (areas?.length > 0) {
      clearErrors(`${question.selector_id}`);
      return true;
    } else {
      setError(`${question.selector_id}`, {
        type: "manual",
        message: "error",
      });
      setForceReloadHelper((prev) => prev + 1);
      return false;
    }
  };

  //dodanie tabeli
  const handleAddSet = (indexParam) => {
    let isNeedValidation = false;
    setInputSets((prevSets) => {
      let additionalInput = [];
      const newSet = question.answers.map((option, index) => {
        let isRequired = getRequiredParam(option?.content);
        if (!!isRequired && !isNeedValidation) {
          isNeedValidation = true;
        }

        if (!!option.copied_column_def) {
          let copied_column_props = JSON.parse(option.copied_column_def);
          setValue(
            `${question.selector_id}_${option.id}_${indexParam}`,
            getValueFromPreviousAnswers(
              `${getQuestionForOption(option).selector_id}_${
                copied_column_props.answer_id
              }_${indexParam}`
            )
          );
        }

        //sprawdzenie czy wystepuje tabela w tabeli
        if (
          getAnswerType(option.content) ===
            M1_AnswersTypeEnum.MultipleColumn.value &&
          !option.copied_column_def
        ) {
          additionalInput.push(returnInputForTable(option, indexParam));
          return;
        }

        //nie wystepuje to zworc normalnego inputa
        return returnInputForTable(option, indexParam);
      });
      if (additionalInput.length > 0) {
        let index = setsIndex + 1;
        if (typeof indexParam === "number") {
          index = indexParam;
        }
        const endSet = [
          ...newSet,
          <div className="bg-white">
            <Row>
              <Col md={9}>{additionalInput}</Col>
              <Col className="d-flex" md={3}>
                {" "}
                <Button
                  className="btn-add2"
                  type="button"
                  onClick={() => handleAddTableRow(index)}
                >
                  Zatwierdź zadanie i kompetencję
                </Button>
              </Col>
              {!checkForAnswers(index, isNeedValidation) && (
                <div class="custom-validation">
                  Dodaj przynajmniej jedną parę zadania i kompetencji dla tego
                  stanowiska
                </div>
              )}
            </Row>
          </div>,
        ];
        return [...prevSets, endSet];
      } else {
        return [...prevSets, newSet];
      }
    });
  };

  //zwraca wartość odpowiedzi dla kolumny skopiowanej
  const getValueFromPreviousAnswers = (id) => {
    if (id in columnCopiedAnswersData) {
      return columnCopiedAnswersData[id];
    } else {
      return "";
    }
  };

  //funkcja sprawdzajaca czy na bieżacej stronie istnieja inne rodzaje pytań od podanego typu
  const checkIfIsOtherTypeOfQuestionsOnSite = (type) => {
    for (const element of currentPage?.questions) {
      if (element.type !== type) {
        return true;
      }
    }
    return false;
  };

  //usuniecie tabeli
  const handleDeleteSet = (setIndex) => {
    let data = getValues();
    for (const key in data) {
      if (key.startsWith(question.selector_id) && key.endsWith(setIndex + 1)) {
        unregister(key);
      }
      if (
        key.startsWith(`answer_` + question.selector_id) &&
        key.endsWith(setIndex + 1)
      ) {
        unregister(key);
      }
    }
    unregister(`${question.selector_id}_table_0`);
    if (setsIndex === 1) {
      setSetsIndex((prev) => prev - 1);
    }
    setDeleteTableRowTrigger((prev) => prev + 1);
  };

  //sprawdzenie czy dane pole jest wymage
  function getRequiredParam(string) {
    let separatedArray = string?.split(";");

    return separatedArray.includes("tak");
  }

  function setSelectBoxId(id) {
    const data = getValues();

    const filteredKeys = Object.keys(data).filter((key) =>
      key.startsWith(`${question.selector_id}`)
    );

    filteredKeys?.forEach((key) => {
      setValue(key, false);
    });

    setValue(`${question.selector_id}_${id}`, true);
    setSelectedId(id);
  }

  //funkcja wyciagajaca w rejestru liczbe zestawod dla pytania
  function getHighestIndexFromSets(array, index) {
    let max = null;
    Object.keys(array)?.forEach((key) => {
      if (key.startsWith(index)) {
        const indexOfUnderscore = key.lastIndexOf("_");
        if (indexOfUnderscore !== -1) {
          const lastUnderscoreIndex = parseInt(
            key.substring(indexOfUnderscore + 1)
          );
          if (
            !isNaN(lastUnderscoreIndex) &&
            (maxTime === null || lastUnderscoreIndex > max)
          ) {
            max = lastUnderscoreIndex;
          }
        }
      }
    });
    return max;
  }

  //funkcja pobierajaca dane dla inputa
  function labelName(string) {
    let separatedArray = string.split(";");
    return separatedArray[0];
  }

  let validationObj = null;
  let scale_definition = null;
  let question_relation = null;
  let relationMin = null;
  let relationMax = null;

  //funkcja pobierajaca dane dla inputa
  function getAnswerType(string) {
    let separatedArray = string.split(";");
    let firstValue = parseInt(separatedArray[1]);
    let secondValue = parseInt(separatedArray[2]);

    if (!isNaN(firstValue)) {
      return firstValue;
    } else if (!isNaN(secondValue)) {
      return secondValue;
    } else {
      return null;
    }
  }

  //funkcja reindeksujaca czyści stare klucze i ustawia nowe
  function setNewIndexForTable(daxta) {
    let data = getValues();
    const groupedData = {};

    for (const key in data) {
      if (key.split("_").length === 3) {
        const [selector, , lastIndexValue] = key.split("_");
        groupedData[selector] = groupedData[selector] || {};
        groupedData[selector][lastIndexValue] = {
          ...groupedData[selector][lastIndexValue],
          [key]: data[key],
        };
        delete data[key];
      }
    }

    const reindexedObject = {};

    for (const [key, value] of Object.entries(groupedData)) {
      reindexedObject[key] = {};
      let index = 1;
      for (const innerValue of Object.values(value)) {
        reindexedObject[key][index] = innerValue;
        index++;
      }
    }
    const updatedData = setDataToUpdate(reindexedObject);

    return { ...data, ...updatedData };
  }

  //pomocnicza funkcja reindeksująca tworząca jedną tablice dla tabel która wstawiamy do odpowiedzi
  function setDataToUpdate(data) {
    let table = [];
    for (let key in data) {
      for (let subKey in data[key]) {
        let index = subKey;
        let valueKeys = Object.keys(data[key][subKey]);
        for (let i = 0; i < valueKeys.length; i++) {
          let valueKey = valueKeys[i];
          let parts = valueKey.split("_");
          parts[parts.length - 1] = index;
          let newKey = parts.join("_");
          data[key][subKey][newKey] = data[key][subKey][valueKey];
          if (newKey !== valueKey) {
            delete data[key][subKey][valueKey];
          }
        }
        table.push(data[key][subKey]);
      }
    }

    const obj = table.reduce((acc, curr) => {
      return { ...acc, ...curr };
    }, {});

    return obj;
  }

  //funkcja zwracajaca cialo inputa danego typu dla tabeli
  function returnInputForTable(option, indexParam) {
    let index = setsIndex;
    if (indexParam) {
      index = indexParam;
    }
    let isCopied = false;
    if (!!option.copied_column_def) {
      isCopied = true;
    }
    if (isNaN(index)) {
      index = inputSets.length + 1;
    }

    switch (getAnswerType(option.content)) {
      case M1_AnswersTypeEnum.Textarea.value:
        return (
          <TextAreaControl
            id={`${question.selector_id}_${option.id}_${index}`}
            key={`${question.selector_id}_${option.id}_${index}`}
            readOnly={isCopied ? true : false}
            label={
              labelName(option.content) +
              (getRequiredParam(option.content) ? "*" : "")
            }
            refs={{
              ...register(`${question.selector_id}_${option.id}_${index}`, {
                ...(getRequiredParam(option.content)
                  ? {
                      required: InputValidationConstants.required,
                    }
                  : {}),
              }),
            }}
            errors={errors}
          />
        );
      case M1_AnswersTypeEnum.Date.value:
        const isChromium = AppHelpers.isChromium();
        
        return (<>
          {!isChromium ? (
                      <MonthYearInput
                      id={`${question.selector_id}_${option.id}_${index}`}
                      label={
                        labelName(option.content) +
                        (getRequiredParam(option.content) ? "*" : "")
                      }
                      readOnly={isCopied ? true : false}
                      setTableTrigger={setTableTrigger}
                      refs={{
                        ...register(`${question.selector_id}_${option.id}_${index}`, {
                          ...(getRequiredParam(option.content)
                          ? {
                              required: InputValidationConstants.required,
                            }
                          : {}),
                          pattern: {
                            value: /^\d{4}-\d{2}$/,
                            message: "Wprowadź datę w formacie RRRR-MM",
                          }
                        })
                      }}
                      errors={errors}
                      setError={setError}
                      clearErrors={clearErrors}
                    />
          ): (
            <DateTimeControl
            id={`${question.selector_id}_${option.id}_${index}`}
            label={
              labelName(option.content) +
              (getRequiredParam(option.content) ? "*" : "")
            }
            readOnly={isCopied ? true : false}
            type={!isChromium ? "date" : "month"}
            refs={{
              ...register(`${question.selector_id}_${option.id}_${index}`, {
                ...(getRequiredParam(option.content)
                  ? {
                      required: InputValidationConstants.required,
                    }
                  : {}),
              }),
            }}
            errors={errors}
          />
          )}
          </>
        );
      case M1_AnswersTypeEnum.Number.value:
        return (
          <NumberControl
            id={`${question.selector_id}_${option.id}_${index}`}
            key={`${question.selector_id}_${option.id}_${index}`}
            readOnly={isCopied ? true : false}
            label={
              labelName(option.content) +
              (getRequiredParam(option.content) ? "*" : "")
            }
            refs={{
              ...register(`${question.selector_id}_${option.id}_${index}`, {
                ...(getRequiredParam(option.content)
                  ? {
                      required: InputValidationConstants.required,
                    }
                  : {}),
              }),
            }}
            errors={errors}
          />
        );
      case M1_AnswersTypeEnum.Text.value:
        return (
          <InputControl
            id={`${question.selector_id}_${option.id}_${index}`}
            key={`${question.selector_id}_${option.id}_${index}`}
            readOnly={isCopied ? true : false}
            label={
              labelName(option.content) +
              (getRequiredParam(option.content) ? "*" : "")
            }
            refs={{
              ...register(`${question.selector_id}_${option.id}_${index}`, {
                ...(getRequiredParam(option.content)
                  ? {
                      required: InputValidationConstants.required,
                    }
                  : {}),
              }),
            }}
            errors={errors}
          />
        );
      case M1_AnswersTypeEnum.MultipleColumn.value:
        return (
          <InputControl
            id={`answer_${question.selector_id}_${option.id}_${index}`}
            key={`answer_${question.selector_id}_${option.id}_${index}`}
            readOnly={isCopied ? true : false}
            onChange={(value) => removeAmpersand(value, `answer_${question.selector_id}_${option.id}_${index}`)}
            label={labelName(option.content) + (false ? "*" : "")}
            refs={{
              ...register(
                `answer_${question.selector_id}_${option.id}_${index}`,
                {
                  ...(false
                    ? {
                        required: InputValidationConstants.required,
                      }
                    : {}),
                }
              ),
            }}
            errors={errors}
          />
        );
      case M1_AnswersTypeEnum.OptionList.value:
        let answersObj = JSON.parse(option?.many_answers_column);
        return (
          <div>
            <div className="scale-label">
              <label className="form-label" style={{ height: "50px" }}>
                {labelName(option.content) +
                  (getRequiredParam(option.content) ? "*" : "")}
              </label>
            </div>
            <div>
              <RadioControl
                id={`${question.selector_id}_${option.id}_${index}`}
                label=""
                hiddenLabel={true}
                options={answersObj}
                refs={{
                  ...register(`${question.selector_id}_${option.id}_${index}`, {
                    ...(getRequiredParam(option.content)
                      ? {
                          required: InputValidationConstants.required,
                        }
                      : {}),
                  }),
                }}
                errors={errors}
              />
            </div>
          </div>
        );
      default:
        return null;
    }
  }

  function checkIsSeperate(array) {
    for (let i = 0; i < array.length; i++) {
      if (array[i].isSeparate === true) {
        return true;
      }
    }
    return false;
  }

  function removeAmpersand(value, id) {
    let valueHelper = value.replace(/&/g, '');
    setValue(id, valueHelper);
}

  useEffect(() => {
    if (!!question) {
      if (!!question.validation_rules) {
        validationObj = JSON.parse(question.validation_rules);
      }

      if (!!question.scale_definition) {
        scale_definition = JSON.parse(question.scale_definition);
      }

      if (!!question?.question_relation) {
        question_relation = JSON.parse(question?.question_relation)[0];
        let condRelationArray = question_relation?.type_value.split("");
        if (condRelationArray?.includes(">")) {
          relationMin = question_relation.question_value;
        }
        if (condRelationArray?.includes("<")) {
          relationMax = question_relation.question_value;
        }
      }

      let matchingObjects = conditionsArray.filter(
        (obj) => obj.question_selector_id === `${question.selector_id}`
      );
      let isHidden = false;
      if (matchingObjects) {
        if (checkIsSeperate(matchingObjects)) {
          isHidden = matchingObjects.every((obj) =>
            handleInputChange(obj.selector_id, matchingObjects)
          );
        } else {
          isHidden = matchingObjects.some((obj) =>
            handleInputChange(obj.selector_id, matchingObjects)
          );
        }
      }

      if (isHidden) {
        let dataValues = getValues();
        if (inputSets.length > 0 && shouldRerender) {
          setInputSets([]);
          setIsTableInit(false);
          setSetsIndex(1);
        }
        if (areas.length > 0) {
          setAreas([]);
        }
        Object.keys(dataValues).forEach((key) => {
          if (key.includes(question.selector_id)) {
            unregister(key);
          }
        });
        setInputElement(null);
      } else {
        switch (question.type) {
          //Input tekstowy
          case M1_QuestionTypeEnum.Text.value:
            setInputElement(
              <div>
                <div className="scale-label">
                  <label
                    className="form-label"
                    for={question.selector_id}
                    style={{ height: "50px" }}
                  >
                    {question.name + (question.required ? "*" : "")}
                  </label>
                </div>
                {question?.description ? (
                  <div className="description-element">
                    <img
                      src={AppHelpers.svgBase64(IconInfo)}
                      className="description-icon"
                      alt="Informacja"
                    />
                    <p class="description-paragraph" data-id="33:4107">
                      {question.description}
                    </p>
                  </div>
                ) : null}
                <InputControl
                  id={question.selector_id}
                  label=""
                  refs={{
                    ...register(question.selector_id, {
                      ...(question.required
                        ? { required: InputValidationConstants.required }
                        : {}),
                      maxLength: {
                        value: !!validationObj?.maxValue
                          ? validationObj.maxValue
                          : 54,
                        message: InputValidationConstants.maxLength.replace(
                          "{placeholder}",
                          !!validationObj?.maxValue
                            ? validationObj.maxValue
                            : 54
                        ),
                      },
                      minLength: {
                        value: !!validationObj?.minValue
                          ? validationObj.minValue
                          : 1,
                        message: InputValidationConstants.minLength.replace(
                          "{placeholder}",
                          !!validationObj?.minValue ? validationObj.minValue : 1
                        ),
                      },
                    }),
                  }}
                  errors={errors}
                />
              </div>
            );
            break;
          //Data
          case M1_QuestionTypeEnum.Date.value:
            const isChromium = AppHelpers.isChromium();


            setInputElement(
              <div>
                <div className="scale-label">
                  <label
                    className="form-label"
                    for={question.selector_id}
                    style={{ height: "50px" }}
                  >
                    {question.name + (question.required ? "*" : "")}
                  </label>
                </div>
                {question?.description ? (
                  <div className="description-element">
                    <img
                      src={AppHelpers.svgBase64(IconInfo)}
                      className="description-icon"
                      alt="Informacja"
                    />
                    <p class="description-paragraph" data-id="33:4107">
                      {question.description}
                    </p>
                  </div>
                ) : null}
                {!isChromium ? (
                                  <MonthYearInput
                                  id={question.selector_id}
                                  label=""
                                  refs={{
                                    ...register(question.selector_id, {
                                      ...(question.required
                                      ? { required: InputValidationConstants.required }
                                      : {}),
                                  pattern: {
                                    value: /^\d{4}-\d{2}$/,
                                    message: "Wprowadź datę w formacie RRRR-MM",
                                  }
                                    })
                                  }}
                                  errors={errors}
                                  setError={setError}
                                  clearErrors={clearErrors}
                                />
                ) : (
                  <DateTimeControl
                  id={question.selector_id}
                  label=""
                  required={true}
                  type={!isChromium ? "date" : "month"}
                  refs={{
                    ...register(question.selector_id, {
                      ...(question.required
                        ? { required: InputValidationConstants.required }
                        : {}),
                      min:
                        !!validationObj?.minValue || !!relationMin
                          ? {
                              value: validationObj?.minValue
                                ? validationObj.minValue
                                : getValues(relationMin),
                              message: validationObj?.minValue
                                ? `Data nie może być wcześniejsza niż ${validationObj.minValue}`
                                : `Data nie może być wcześniejsza niż ${getValues(
                                    relationMin
                                  )}`,
                            }
                          : null,
                      max:
                        !!validationObj?.maxValue || !!relationMax
                          ? {
                              value: validationObj?.maxValue
                                ? validationObj.maxValue
                                : getValues(relationMax),
                              message: validationObj?.maxValue
                                ? `Data nie może być późniejsza niż ${validationObj.maxValue}`
                                : `Data nie może być późniejsza niż ${getValues(
                                    relationMax
                                  )}`,
                            }
                          : null,
                    }),
                  }}
                  errors={errors}
                />
                )}
              </div>
            );
            break;
          //Numer
          case M1_QuestionTypeEnum.Number.value:
            setInputElement(
              <div>
                <div className="scale-label">
                  <label
                    className="form-label"
                    style={{ height: "50px" }}
                    for={question.selector_id}
                  >
                    {question.name + (question.required ? "*" : "")}
                  </label>
                </div>
                {question?.description ? (
                  <div className="description-element">
                    <img
                      src={AppHelpers.svgBase64(IconInfo)}
                      className="description-icon"
                      alt="Informacja"
                    />
                    <p class="description-paragraph" data-id="33:4107">
                      {question.description}
                    </p>
                  </div>
                ) : null}
                <NumberControl
                  id={question.selector_id}
                  type="number"
                  label=""
                  refs={{
                    ...register(question.selector_id, {
                      ...(question.required
                        ? { required: InputValidationConstants.required }
                        : {}),
                      min: {
                        value: !!validationObj?.minValue
                          ? validationObj.minValue
                          : 1,
                        message: `Liczba nie może być mniejsza niż ${
                          !!validationObj?.minValue ? validationObj.minValue : 1
                        }`,
                      },
                      max: !!validationObj?.maxValue
                        ? {
                            value: validationObj?.maxValue,
                            message: `Liczba nie może być większa niż ${validationObj.maxValue}`,
                          }
                        : null,
                    }),
                  }}
                  errors={errors}
                />
              </div>
            );
            break;
          //YesNoSelect
          case M1_QuestionTypeEnum.YesNoSelect.value:
            const options4 = [];
            question.answers?.forEach((option) => {
              options4.push({ label: option.content, value: option.content });
            });

            setInputElement(
              <div>
                <div className="scale-label">
                  <p
                    className="form-label"
                  >
                    {question.name + (question.required ? "*" : "")}
                  </p>
                </div>
                {question?.description ? (
                  <div className="description-element">
                    <img
                      src={AppHelpers.svgBase64(IconInfo)}
                      className="description-icon"
                      alt="Informacja"
                    />
                    <p class="description-paragraph" data-id="33:4107">
                      {question.description}
                    </p>
                  </div>
                ) : null}
                <div className="question-container">
                  <RadioControl
                    id={question.selector_id}
                    label=""
                    hiddenLabel={true}
                    options={options4}
                    refs={{
                      ...register(question.selector_id, {
                        ...(question.required
                          ? { required: InputValidationConstants.required }
                          : {}),
                      }),
                    }}
                    errors={errors}
                  />
                </div>
              </div>
            );
            break;
          //Lista opcji
          case M1_QuestionTypeEnum.OptionList.value:
            question.answers?.sort((a, b) => a.order - b.order);
            const options5 = [];

            let validation_rules = JSON.parse(question.validation_rules);

            if (validation_rules) {
              if (validation_rules?.displayType == 2) {
                question.answers?.forEach((option) => {
                  options5.push({ label: option.content, value: option.id });
                });

                const selectOptions = options5.map((option) => ({
                  name: option.label,
                  value: option.value,
                }));

                const selectElement = (
                  <SelectControl
                    id={`${question.selector_id}_${selectedId}`}
                    onChange={setSelectBoxId}
                    options={selectOptions}
                    ref={register(`${question.selector_id}_${selectedId}`)}
                  />
                );

                setInputElement(
                  <div key={question.name}>
                    <label className="form-label">
                      {question.name + (question.required ? "*" : "")}
                    </label>
                    {selectElement}
                  </div>
                );
              } else {
                const options4 = [];
                question.answers?.forEach((option) => {
                  options4.push({
                    label: option.content,
                    value: option.content,
                  });
                });

                setInputElement(
                  <div>
                    <div className="scale-label">
                      <label className="form-label" style={{ height: "50px" }}>
                        {question.name + (question.required ? "*" : "")}
                      </label>
                    </div>
                    {question?.description ? (
                      <div className="description-element">
                        <img
                          src={AppHelpers.svgBase64(IconInfo)}
                          className="description-icon"
                          alt="Informacja"
                        />
                        <p class="description-paragraph" data-id="33:4107">
                          {question.description}
                        </p>
                      </div>
                    ) : null}
                    <div className="question-container">
                      <RadioControl
                        id={question.selector_id}
                        label=""
                        hiddenLabel={true}
                        options={options4}
                        refs={{
                          ...register(question.selector_id, {
                            ...(question.required
                              ? { required: InputValidationConstants.required }
                              : {}),
                          }),
                        }}
                        errors={errors}
                      />
                    </div>
                  </div>
                );
              }
            } else {
              question.answers?.forEach((option) => {
                options5.push({ label: option.content, value: option.id });
              });

              const checkboxElements = options5.map((option, index) => (
                <CheckboxControl
                  key={index}
                  id={`${question.selector_id}_${index}`}
                  onClick={validateCheckboxes(question.selector_id)}
                  label={option.label}
                  refs={{
                    ...register(`${question.selector_id}_${option.value}`),
                  }}
                />
              ));
              if (errors[question.selector_id]) {
                checkboxElements.push(
                  <span class="color-danger">
                    {errors[question.selector_id].message}
                  </span>
                );
              }

              setInputElement(
                <div>
                  <div className="scale-label">
                    <p
                      className="form-label"
                    >
                      {question.name}
                    </p>
                  </div>
                  {question?.description ? (
                    <div className="description-element">
                      <img
                        src={AppHelpers.svgBase64(IconInfo)}
                        className="description-icon"
                        alt="Informacja"
                      />
                      <p class="description-paragraph" data-id="33:4107">
                        {question.description}
                      </p>
                    </div>
                  ) : null}
                  {checkboxElements}
                </div>
              );
            }
            break;

          //Content
          case M1_QuestionTypeEnum.Content.value:
            let isOtherQuestions = checkIfIsOtherTypeOfQuestionsOnSite(
              M1_QuestionTypeEnum.Content.value
            );
            if (
              !isOtherQuestions &&
              /(?:https?:\/\/)?(?:www\.)?youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)([a-zA-Z0-9_-]{11})/.test(
                question.content
              )
            ) {
              setIsVideoEnded(M1_ContentVideoStatuses.UnValid.value);
            } else {
              question.content = question?.content?.replace(
                /<figure\s+class="media">|<\/figure>/g,
                ""
              );
              setInputElement("");
              return;
            }

            const youtubeRegExp =
              /(?:https?:\/\/)?(?:www\.)?youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)([a-zA-Z0-9_-]{11})/;
            const match = question?.content.match(youtubeRegExp);

            if (match && match[1]) {
              const youtubeVideoId = match[1];
              const opts = {
                playerVars: {
                  autoplay: 0,
                },
              };
              setInputElement(
                <YouTube
                  className="youtube-video"
                  videoId={youtubeVideoId}
                  opts={opts}
                  onEnd={onEndVideo}
                />
              );
            } else {
              setInputElement(null);
            }
            break;

          //Skala
          case M1_QuestionTypeEnum.Scale.value:
            const datalistOptions = [];
            for (
              let value = parseInt(scale_definition.min);
              value <= parseInt(scale_definition.max);
              value += parseInt(scale_definition.step)
            ) {
              datalistOptions.push(
                <option key={value} value={value} label={value} />
              );
            }
            setInputElement(
              <div>
                <div className="scale-label">
                  <label
                    className="form-label"
                    for={question.selector_id}
                    style={{ height: "50px" }}
                  >
                    {question.name}
                  </label>
                </div>
                {question?.description ? (
                  <div className="description-element">
                    <img
                      src={AppHelpers.svgBase64(IconInfo)}
                      className="description-icon"
                      alt="Informacja"
                    />
                    <p class="description-paragraph" data-id="33:4107">
                      {question.description}
                    </p>
                  </div>
                ) : null}
                <div className="row">
                  <span className="mr-1">{scale_definition.min_desc}</span>
                  <div>
                    <input
                      id={question.selector_id}
                      type="range"
                      className="form-range slider"
                      name={question.selector_id}
                      {...register(question.selector_id)}
                      min={scale_definition.min}
                      max={scale_definition.max}
                      step={scale_definition.step}
                      list={question.selector_id + "_values"}
                      value={getValues(question.selector_id)}
                      onChange={(e) => {
                        setValue(question.selector_id, `${e.target.value}`);
                      }}
                    />
                    <datalist id={question.selector_id + "_values"}>
                      {datalistOptions}
                    </datalist>
                  </div>
                  <span className="ml-1">{scale_definition.max_desc}</span>
                </div>
              </div>
            );
            break;

          // Wykres
          case M1_QuestionTypeEnum.Chart.value:
            let isMobileDevice =
              window.matchMedia("(max-width: 768px)").matches;
            let wordsLenght = isMobileDevice ? 1 : 2;
            const chartValues = JSON.parse(question.source_list);
            let chartLabelsShort = chartValues.map((data, index) => {
              let currQuestion = currentPage.questions.find(
                (question) => question.selector_id === data.selector_id
              );

              if (currQuestion) {
                let name = currQuestion.name.trim();
                let words = name.split(" ");
                if (words.length > 1) {
                  return `${words.slice(0, wordsLenght).join(" ")}`;
                } else {
                  return name;
                }
              } else {
                return "";
              }
            });

            let chartLabelsLong = chartValues.map((data, index) => {
              let currQuestion = currentPage.questions.find(
                (question) => question.selector_id === data.selector_id
              );
              if (currQuestion) {
                let name = currQuestion.name.trim();
                if (name.length > 15) {
                  return name.substring(0, 70);
                } else {
                  return name;
                }
              }
            });

            let htThreeValuesBar = [];
            chartValues.filter((value) =>
              getValues(value.selector_id) >= 3
                ? htThreeValuesBar.push({
                    selector_id: value.selector_id,
                    questionName: value.questionName,
                    value: getValues(value.selector_id),
                  })
                : ""
            );
            let setBarIdVisible = !htThreeValuesBar.length < 1;
            const option = {
              scales: {
                ...(screenSize.width <= 768
                  ? {
                      x: {
                        ticks: {
                          maxRotation: 90,
                          minRotation: 90,
                          font: {
                            size: 7,
                            weight: "bold",
                          },
                        },
                      },
                    }
                  : { x: { ticks: { maxRotation: 25, minRotation: 25 } } }),
                y: {
                  min: 0,
                  max: 5,
                  stepSize: 1,
                  ticks: {
                    stepSize: 1,
                    callback: function (value, index, values) {
                      return value;
                    },
                  },
                },
              },
              plugins: {
                tooltip: {
                  callbacks: {
                    title: function (tooltipItem, data) {
                      if (tooltipItem && tooltipItem[0]) {
                        const index = tooltipItem[0].dataIndex;
                        return chartLabelsLong[index];
                      }
                      return "";
                    },
                  },
                },
              },
            };

            const chartData = {
              labels: chartLabelsShort,
              datasets: [
                {
                  label: "kompetencje",
                  backgroundColor: "rgba(146, 0, 87, 0.5)",
                  data: chartValues.map((data) => {
                    return getValues(data.selector_id);
                  }),
                },
              ],
            };

            setInputElement(
              <div
                id="barChartId"
                className={`${setBarIdVisible ? "" : "d-none"}`}
              >
                <Bar data={chartData} options={option}></Bar>
              </div>
            );
            break;

          // Statystyka
          case M1_QuestionTypeEnum.Statistic.value:
            let statValues = JSON.parse(question.source_list);
            let htThreeValues = [];

            statValues.filter((value) =>
              getValues(value.selector_id) >= 3
                ? htThreeValues.push({
                    selector_id: value.selector_id,
                    questionName: value.questionName,
                    value: getValues(value.selector_id),
                  })
                : ""
            );

            let isLabelIdVisible = !htThreeValues.length < 1;
            htThreeValues.sort((a, b) => b.value - a.value);

            setInputElement(
              <div>
                <label
                  id="labelId"
                  className={`form-label ${isLabelIdVisible ? "" : "d-none"}`}
                >
                  {competitions}
                </label>
                <div className="point-list">
                  {" "}
                  {/* Dodanie klasy dla stylowania */}
                  <ul>
                    {htThreeValues.map((data, index) => (
                      <li key={index}>
                        <div className="list-group">
                          {surveyArray.map((value, idx) => {
                            const question = value.questions.find(
                              (question) =>
                                question.selector_id === data.selector_id
                            );
                            return (
                              question && (
                                <div key={idx}>
                                  <span>{question.name}</span>
                                </div>
                              )
                            );
                          })}
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            );

            break;
          case M1_QuestionTypeEnum.Table.value:
            if (shouldRerender) {
              setInputSets([]);
            }
            question.answers?.sort((a, b) => a.order - b.order);
            let additionalInput = [];
            let isAnyColumnConnected = false;
            question.answers.map((option) => {
              if (!!option.copied_column_def) {
                isAnyColumnConnected = true;
                setShouldRerender(false);
                let copied_column_props = JSON.parse(option.copied_column_def);
                if (
                  !isTableInit &&
                  !columnCopiedAnswersData &&
                  !columnCopiedQuestionnaire
                ) {
                  setIsTableInit(true);
                  SurveyService.fetchAnswers(
                    user.id,
                    copied_column_props.questionnaire_id
                  )
                    .then((response) => {
                      setColumnCopiedAnswersData(
                        JSON.parse(response.data.answers)
                      );
                      setCopiedColumnTrigger((prev) => prev + 1);
                    })
                    .catch((error) => {
                      console.error(error);
                    });

                  !columnCopiedQuestionnaire &&
                    SurveyService.fetchSurvey(
                      copied_column_props.questionnaire_id
                    )
                      .then((response) => {
                        setColumnCopiedQuestionnaire(response.data);
                        setCopiedColumnTrigger((prev) => prev + 1);
                      })
                      .catch((error) => {
                        console.error(error);
                      });
                } else {
                  setCopiedColumnTrigger((prev) => prev + 1);
                }
              }
            });

            if (!isAnyColumnConnected) {
              setAreas([]);
              for (let x = 1; x <= setsIndex; x++) {
                let textFromAnswer = getValues(
                  `${question.selector_id}_table_${x}`
                );
                let answersElements = textFromAnswer?.split(";");
                answersElements?.forEach((answer) => {
                  if (!answer) {
                    return;
                  }
                  setAreas((prevAreas) => {
                    const updatedAreas = [...prevAreas];
                    updatedAreas[x] = {
                      ...updatedAreas[x],
                      text: [...(updatedAreas[x]?.text || []), answer],
                    };
                    return updatedAreas;
                  });
                });
              }

              for (let x = 1; x <= setsIndex; x++) {
                handleAddSet(x);
              }
              setTableTrigger((prev) => prev + 1);
            }
            break;
          case M1_QuestionTypeEnum.Area.value:
            if (!isTableInit) {
              let areasString = getValues(question.selector_id);

              if (areasString) {
                setAreas([]);
                let areasArray = areasString
                  .split(";")
                  .map((area) => area.trim());

                areasArray?.forEach((element) => {
                  setAreas((prevAreas) => [...prevAreas, element]);
                });
              }
              setIsTableInit(true);
            }

            setInputElement(
              <div>
                <div className="scale-label">
                  <div
                    className="form-label"
                    for={question.selector_id}
                    style={{ height: "50px" }}
                  >
                    {question.name + (question.required ? "*" : "")}
                  </div>
                </div>
                {question?.description ? (
                  <div className="description-element">
                    <img
                      src={AppHelpers.svgBase64(IconInfo)}
                      className="description-icon"
                      alt="Informacja"
                    />
                    <p class="description-paragraph" data-id="33:4107">
                      {question.description}
                    </p>
                  </div>
                ) : null}
                <Row>
                  <Col md={12}>
                    <AutocompleteControl
                      id={`area`}
                      label=""
                      onSearch={searchDevelopmentArea}
                      onSelect={(areaName, areaId) => handleAddAreaRow(areaName, areaId)}
                      refs={{
                        ...register(`area`),
                      }}
                    />
                  </Col>
                </Row>
                {areas?.map((area, index) => (
                  <Row className="ml-1" key={index}>
                    <Col md={10} style={{ marginBottom: "20px"}}>
                      <FontAwesomeIcon icon={faArrowAltCircleRight} style={{ marginTop: "4px", marginRight: "5px", color: "#e6007e" }} />
                      {area}
                    </Col>

                    <Col md={2} style={{ marginBottom: "20px"}}>
                      <Button
                        className="btn-sm mx-2 btn-delete"
                        type="button"
                        variant="danger"
                      >
                        <span onClick={() => handleRemoveAreaRow(index)}>
                          <img
                            className="delete-btn"
                            src={AppHelpers.svgBase64(XCircle)}
                            alt="usuń"
                          />
                          usuń informacje
                        </span>
                      </Button>
                    </Col>
                  </Row>
                ))}
                {!checkForAnswers1() && (
                  <div class="custom-validation">
                    Dodaj przynajmniej jedno szkolenie
                  </div>
                )}
              </div>
            );
            break;
          case M1_QuestionTypeEnum.Feedback.value:
            setInputElement(
              <Button
                key="summary"
                variant="primary"
                className="mr-1 generate-pdf-btn"
                onClick={downloadFeedbackPDF}
              >
                <span className="btns">
                  Wygeneruj informacje zwrotna w pliku pdf
                </span>
              </Button>
            );
            break;
          default:
            setInputElement(<p>Nieobsługiwany typ pytania</p>);
            break;
        }
      }
    }
  }, [question, previousFormValues, setValue, setsIndex, areaTrigger]);

  return (
    <CardBody
      id={`questionCard-${question.selector_id}`}
      className={`${
        question.type === M1_QuestionTypeEnum.Table.value ||
        question.type === M1_QuestionTypeEnum.Content.value
          ? "bg-light"
          : ""
      } bg-gradient ${question.conditional_rules !== "[]" ? "d-none" : ""}`}
    >
      {question.type !== M1_QuestionTypeEnum.Content.value &&
      question.type !== M1_QuestionTypeEnum.Feedback.value ? (
        <img className="line-380" src={AppHelpers.svgBase64(QuestionLine)} alt="Linia" />
      ) : null}
      <div>
        {question.type === M1_QuestionTypeEnum.Table.value ? (
          <label className="form-label">{question.name}</label>
        ) : null}
        {question?.description &&
        question.type === M1_QuestionTypeEnum.Table.value ? (
          <div className="description-element">
            <img src={AppHelpers.svgBase64(IconInfo)} className="description-icon" alt="Informacja" />
            <p class="description-paragraph" data-id="33:4107">
              {question.description}
            </p>
          </div>
        ) : null}
        <div className="mb-3">
          {question.content && (
            <div dangerouslySetInnerHTML={{ __html: question.content }} />
          )}
        </div>
        {inputElement}
      </div>
    </CardBody>
  );
};

export default Question;
